<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal create-notice-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="nextStep()" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">{{data.id ? 'Edit' : 'Create'}} a New Notice
                        {{noticesService.wizardType=='scratch' ? 'from scratch' : ''}}
                        {{noticesService.wizardType=='templates' ? 'from template' : ''}}
                        {{noticesService.wizardType=='pdf' ? 'from pdf' : ''}}
                    </h4>
                </div>
                <div class="modal-body">
                    <div *ngIf="noticesService.wizardType=='scratch'">
                        <div class="form-group" id="summernote-scratch">{{message}}</div>
                    </div>
                    <div *ngIf="noticesService.wizardType=='templates'">
                        <div *ngIf="noticesService.choosingTemplate">
                            <div class="fx-column animated fadeInLeft" *ngIf="action === 'playlist'">
                                <!--<div class="fx-column animated fadeInLeft" *ngIf="true">-->
                                <div class="_module-header-block">
                                    <div class="module-search">
                                        <div class="input-group">
                                            <input class="form-control" name="search" [ngModel]="search.playlist" placeholder="Search Playlists">
                                            <div class="input-group-btn">
                                                <button type="button" class="btn btn-default" aria-label="Search">
                                                    <span class="glyphicon glyphicon-search"></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="_items-templates" ss-container>
                                    <ul class="list-unstyled" >
                                        <!--<li *ngFor="item in listPlaylist | filter : search.playlist" let-index="index">-->
                                        <li *ngFor="let item of noticesService.data.allNotices.data.playlists">
                                            <a href="" (click)="showNoticesByPlaylist(item)" class="_item">
                                                <span [innerHtml]="item.title"></span>
                                                <span class="_info">
                                                    <span class="i-count" [innerHtml]="item.announcements"></span>
                                                    <i class="fa fa-arrow-right i-arrow"></i>
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="fx-column animated fadeInLeft" *ngIf="action === 'notices'">
                                <div class="_module-header-block">
                                    <div class="module-search">
                                        <div class="input-group">
                                            <input class="form-control" name="search" [ngModel]="search.notice" placeholder="Search Notices">
                                            <div class="input-group-btn">
                                                <button type="button" class="btn btn-default" aria-label="Search">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                                <button uib-tooltip="Filter Notices"
                                                        tooltip-placement="bottom"
                                                        type="button"
                                                        class="btn btn-default btn-show-filter" [ngClass]="{'active': showFilter}" aria-label="Filter" (click)="showFilter = !showFilter">
                                                    <i class="fa fa-filter"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="module-notice-filter">
                                        <div class="filter-form" *ngIf="showFilter">
                                            <div class="filter-status">
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class="checkbox">
                                                            <label>
                                                                <input type="checkbox" [ngModel]="filtered.status.active">
                                                                <span class="status"><i class="_active"></i> Active</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="checkbox">
                                                            <label>
                                                                <input type="checkbox" [ngModel]="filtered.status.expired">
                                                                <span class="status"><i class="_expired"></i> Expired</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class="checkbox">
                                                            <label>
                                                                <input type="checkbox" [ngModel]="filtered.status.future">
                                                                <span class="status"><i class="_future"></i> Future</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="checkbox">
                                                            <label>
                                                                <input type="checkbox" [ngModel]="filtered.status.archived">
                                                                <span class="status"><i class="_archived"></i> Archived</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="filter-categories" uib-dropdown>
                                                <span class="cat-label" uib-dropdown-toggle>
                                                    Select Categories
                                                    <span class="caret pull-right m-t-sm"></span>
                                                </span>
                                                <div uib-dropdown-menu>
                                                    <ul ss-container role="menu" style="height: 60px;overflow: auto">
                                                        <li *ngFor="let category of categoriesList">
                                                            <div class="checkbox">
                                                                <label>
                                                                    <input type="checkbox" [ngModel]="filtered.category[category.id]">
                                                                    <span [innerHtml]="category.title"></span>
                                                                </label>
                                                            </div>
                                                        </li>
                                                    </ul>

                                                </div>
                                            </div>
                                            <script>
                                                $(document).on('click', '.dropdown-menu', function (e) {
                                                    e.stopPropagation();
                                                });
                                            </script>
                                        </div>
                                        <div class="filter-labels" *ngIf="!showFilter">
                                            <span *ngFor="let v of filtered.status">
                                                <span *ngIf="v">{{v}}</span>
                                                <a href="" (click)="filtered.status[v]=false"></a>
                                            </span>
                                            <span *ngFor="let v of filtered.category">
                                                <span *ngIf="v">{{getCategoryNameById(v)}}</span>
                                                <a href="" (click)="filtered.category[v]=false"></a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="_items-templates" ss-container>
                                    <div >
                                        <ul class="list-unstyled status" >
                                            <!--<li class="droupdown " [ngClass]="'_' + item.status"  uib-dropdown *ngFor="item in listNotices-->
                                            <!--| orderBy: 'id' : 1-->
                                            <!--| filter : search.notice-->
                                            <!--| noticesFilter: filtered-->
                                            <!--track by $index">-->
                                            <li class="droupdown " [ngClass]="'_' + item.status"  uib-dropdown
                                                *ngFor="let item of noticesService.data.allNotices.data.notices; trackBy: index;">
                                                <div class="_item" [ngClass]="{'active': noticesService.currentNotice.id == item.id}" (click)="setCurrentNotice(item)" >
                                                    <span [innerHtml]="item.title || 'empty'"></span>
                                                </div>
                                                <a class="_info" href="" id="droupdown_{{index}}" uib-dropdown-toggle><i class="glyphicon glyphicon-option-vertical i-copy"></i></a>
                                                <ul uib-dropdown-menu role="menu" class="dropdown-menu pull-right">
                                                    <li><a ui-sref="main.notice_edit({step: 'message', noticeId: item.id})"><i class="fa fa-pencil"></i> Edit</a></li>
                                                    <li *ngIf="item.status != 'archived'"><a href="" (click)="deleteItem(item)"><i class="fa fa-archive"></i> Archive</a></li>
                                                    <li *ngIf="item.status == 'archived'"><a href="" (click)="restoreItem(item)"><i class="fa fa-archive"></i> Restore</a></li>
                                                    <li><a ui-sref="main.notice_create({step: 'message', type: 'copy', noticeId: item.id})"><i class="fa fa-copy"></i> Create copy</a></li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!noticesService.choosingTemplate">
                            <div class="form-group" id="summernote-template">{{message}}</div>
                        </div>
                    </div>
                    <div *ngIf="noticesService.wizardType=='pdf'">
                        <div style="display: none" class="btn btn-primary relative hide-overflow">
                            <i class="fa fa-file-image-o"></i> Upload PDF
                            <input #pdfFileInput id="pdfFileInput" name="pdfFileInput"
                                   class="hidden-file-input" type="file" (change)="onPdfChange($event)">
                        </div>
                        <div (click)="launchFilePicker()">
                            <div fileDrop
                                [ngClass]="{'file-is-over': fileIsOver}"
                                [options]="options"
                                (fileOver)="fileOver($event)"
                                (onFileDrop)="onFileDrop($event)"
                                class="well my-drop-zone">
                                You can drag and drop files here to add them. <br> Or Click Here
                            </div>
                        </div>
                        <div class="pdf-wrapper">
                            <pdf-viewer *ngIf="pdfSrc" [src]="pdfSrc" [page]="1" [zoom]="0.6" [fit-to-page]="true"
                                        [show-all]="false" [render-text]="true" style="display: block;">
                            </pdf-viewer>
                        </div>
                    </div>
                    <div class="_footer" *ngIf="noticesService.step && noticesService.step != 'main'">
                        <div class="_f-wrap">
                            <a (click)="back()" class="btn btn-back btn-default btn-lg">Back</a>
                            <button type="submit" class="btn btn-save btn-primary btn-lg">
                                <span *ngIf="noticesService.step != 'schedule'">Save & Continue</span>
                                <span *ngIf="noticesService.step == 'schedule'">Save</span>
                            </button>
                            <div class="_steps-items">
                                <ul>
                                    <li [ngClass]="{'active': noticesService.step == 'message' || noticesService.step == 'templates'}"><span>Notice Message</span></li>
                                    <li [ngClass]="{'active': noticesService.step == 'schedule'}"><span>Schedule</span></li>
                                    <li [ngClass]="{'active': noticesService.step == 'info'}"><span>Notice Info</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/notices/create-notice-modal/create-notice-modal.component.html